import { useLang } from 'hooks/lang';

import { Column } from 'components/Blocks';

import waitingAnimation from 'assets/animations/waiting-hour-glass.json';

import { SVGAnimation } from 'components/SVGAnimation';

export function FromDifferenceSource() {
  const { t } = useLang();

  return (
    <Column alignItems="center" gap="2">
      <SVGAnimation animationData={waitingAnimation} loop size={90} />

      <h6>{t('reprice-from-another-source')}</h6>

      <p>{t('please-wait-until-the-current-reprice-is-done')}</p>
    </Column>
  );
}
